// import React, { useEffect, useRef } from "react";
// import { gsap } from "gsap";
// import { Icon } from "@iconify/react";

// const steps = [
//   {
//     number: "01",
//     title: "Deep Discovery & Planning",
//     text: "Every great solution starts with understanding. We take the time to learn about your business, challenges, and goals.",
//   },
//   {
//     number: "02",
//     title: "Development & Implement.",
//     text: "Every great solution starts with understanding. We take the time to learn about your business, challenges, and goals.",
//   },
//   {
//     number: "03",
//     title: "Optimization & Support.",
//     text: "Every great solution starts with understanding. We take the time to learn about your business, challenges, and goals.",
//   },
// ];

// export default function WorkingProcess() {
//   const lineRefs = useRef([]);
//   const numberRefs = useRef([]);
//   const cardRefs = useRef([]);

//   useEffect(() => {
//     gsap.set(lineRefs.current, { backgroundColor: "#444" });
//     gsap.set(numberRefs.current, { backgroundColor: "#fff", color: "#000" });
//   }, []);

//   const handleHover = (index, hover) => {
//     const color = hover ? "#F26A33" : "#fff";
//     const bg = hover ? "#1a1a1a" : "#0d0d0d";

//     gsap.to(cardRefs.current[index], {
//       backgroundColor: hover ? "#111" : "#0d0d0d",
//       duration: 0.5,
//       ease: "power2.out",
//     });

//     gsap.to(numberRefs.current[index], {
//       backgroundColor: hover ? "#F26A33" : "#fff",
//       color: hover ? "#fff" : "#000",
//       scale: hover ? 1.2 : 1,
//       duration: 0.4,
//       ease: "power2.out",
//     });

//     gsap.to(lineRefs.current[index], {
//       backgroundColor: hover ? "#F26A33" : "#444",
//       duration: 0.5,
//       ease: "power2.out",
//     });
//   };

//   return (
//     <>
//       <section className="relative flex flex-col items-center justify-center bg-black text-white py-32 px-6 sm:px-10 md:px-16 lg:px-24 overflow-hidden">
//         <div className="relative z-10 max-w-screen-2xl w-full flex flex-col md:flex-row justify-between items-start gap-12 ">
//           {/* Left Section */}
//           <div className="w-full lg:w-1/2">
//             <button className="bg-white/10 border border-white/20 px-5 py-2 rounded-full text-sm mb-6 hover:bg-white/20 transition-all">
//               OUR WORKING PROCESS
//             </button>
//             {/* <p className="text-green-400 mb-2">// OUR WORKING PROCESS</p> */}

//             <h2 className="animate-text text-5xl lg:text-4xl xl:text-7xl font-light text-gray-400 mb-4 leading-tight">
//               Turning Your Business{" "}
//               <span className="text-white font-light">Goals Into</span>
//             </h2>
//             <h2 className="animate-text text-5xl lg:text-4xl xl:text-7xl font-light text-white leading-tight mb-4">
//               Seamless Digital
//             </h2>


//             <p className="text-gray-400 mb-8">
//               Custom software solutions tailored to your business needs development.
//             </p>

//           </div>

//           {/* Right Section */}
//           <div className="w-full lg:w-1/2 flex flex-col items-start">
//             {steps.map((step, index) => (
//               <div key={index} className="flex items-start relative ">
//                 {/* Number & Line */}
//                 <div className="flex flex-col items-center">
//                   <div
//                     ref={(el) => (numberRefs.current[index] = el)}
//                     className="w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center font-bold text-lg mb-2 border-2 border-gray-600 shadow-md transition-all"
//                   >
//                     {step.number}
//                   </div>
//                   {index !== steps.length - 1 && (
//                     <div
//                       ref={(el) => (lineRefs.current[index] = el)}
//                       className="w-1 h-20 sm:h-28 bg-gray-700"
//                     ></div>
//                   )}
//                 </div>

//                 {/* Step Card */}
//                 <div
//                   ref={(el) => (cardRefs.current[index] = el)}
//                   className="bg-[#0d0d0d] px-5 sm:px-8 py-8 sm:py-10 rounded-xl ml-5 sm:ml-8 w-full shadow-md hover:shadow-orange-500/20 transition-all"
//                   onMouseEnter={() => handleHover(index, true)}
//                   onMouseLeave={() => handleHover(index, false)}
//                 >
//                   <h3 className="font-semibold text-lg sm:text-xl md:text-2xl mb-3 sm:mb-4">
//                     {step.title}
//                   </h3>
//                   <p className="text-gray-400 text-sm sm:text-base leading-relaxed">
//                     {step.text}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Background overlay image */}
//         <div className="absolute inset-0 bg-[url('https://themejunction.net/html/tekmino/demo/assets/images/process/process-2-bg.webp')] bg-cover bg-center opacity-80" ></div>
//       </section>
//     </>
//   );
// }


import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Icon } from "@iconify/react";

gsap.registerPlugin(ScrollTrigger);

const steps = [
  {
    number: "01",
    title: "Design",
    text: "We convert ideas into impactful, user-centric designs that blend creativity, clarity, and functionality helping your brand stand out in Dubai’s competitive digital landscape.",
  },
  {
    number: "02",
    title: "Development",
    text: "Our expert developers bring designs to life using clean, scalable, and high-performance code building reliable digital products that grow with your business.",
  },
  {
    number: "03",
    title: "Deployment & Growth",
    text: "From launch to long-term success, we ensure smooth deployment, seamless system integration, and ongoing technical support so your digital product performs at scale.",
  },
];

export default function ItSolution3DWorkStructure() {
  const lineRefs = useRef([]);
  const numberRefs = useRef([]);
  const cardRefs = useRef([]);
  const leftRef = useRef(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    gsap.set(lineRefs.current, { backgroundColor: "#444" });
    gsap.set(numberRefs.current, { backgroundColor: "#fff", color: "#000" });
    gsap.set(cardRefs.current, { opacity: 0, y: 80 });

    // Left section animation
    gsap.fromTo(
      leftRef.current,
      { opacity: 0, x: -100 },
      {
        opacity: 1,
        x: 0,
        duration: 1.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
        },
      }
    );

    // Each card animation on scroll
    cardRefs.current.forEach((card, i) => {
      gsap.to(card, {
        opacity: 1,
        y: 0,
        duration: 1,
        delay: i * 0.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: card,
          start: "top 85%",
        },
      });
    });
  }, []);

  const handleHover = (index, hover) => {
    gsap.to(cardRefs.current[index], {
      backgroundColor: hover ? "#111" : "#0d0d0d",
      scale: hover ? 1.03 : 1,
      duration: 0.4,
      ease: "power2.out",
    });

    gsap.to(numberRefs.current[index], {
      backgroundColor: hover ? "#F26A33" : "#fff",
      color: hover ? "#fff" : "#000",
      scale: hover ? 1.2 : 1,
      duration: 0.4,
      ease: "power2.out",
    });

    gsap.to(lineRefs.current[index], {
      backgroundColor: hover ? "#F26A33" : "#444",
      duration: 0.4,
      ease: "power2.out",
    });
  };

  return (
    <section
      ref={sectionRef}
      className="relative flex flex-col items-center justify-center bg-black text-white py-28 px-6 sm:px-10 md:px-16 lg:px-24 overflow-hidden"
    >
      {/* Overlay background */}
      <div className="absolute inset-0 bg-[url('https://api.visko.group/public/assets/img/uploads/gallery/photo-1758520144667-.webp')] bg-cover bg-center opacity-60"></div>

      {/* Content */}
      <div className="relative z-10 max-w-screen-2xl w-full flex flex-col md:flex-row justify-between items-start gap-16">
        {/* Left Section */}
        <div ref={leftRef} className="w-full lg:w-1/2">

          <button className="bg-white/10 border border-white/20 px-5 py-2 mb-6 rounded-full text-sm hover:bg-white/20 transition-all flex">
            <Icon
              icon="material-symbols:lightbulb-2-rounded"
              className="mr-1.5 text-[#F26A33] drop-shadow-[0_0_6px_#F26A33]"
              width="22"
              height="20"
            />
            OUR DIGITAL WORKING PROCESS
          </button>

          <h2 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-light text-gray-400 md:mb-4 leading-tight">
            Transforming Business{" "}
            <span className="text-white font-light">Goals Into Seamless</span>
          </h2>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-light text-white leading-tight mb-6">
             Digital Solutions
          </h2>

          <p className="text-gray-400 max-w-md mb-10  sm:text-base leading-relaxed">
            We deliver custom IT and digital solutions for Dubai businesses from concept to launch backed by continuous optimization, scalability, and long-term support.
          </p>
        </div>

        {/* Right Section */}
        <div className="w-full lg:w-1/2 flex flex-col items-start space-y-2">
          {steps.map((step, index) => (
            <div key={index} className="flex items-start relative">
              {/* Number & Line */}
              <div className="flex flex-col items-center">
                <div
                  ref={(el) => (numberRefs.current[index] = el)}
                  className="w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center font-bold text-lg mb-2 border-2 border-gray-600 shadow-md transition-all"
                >
                  {step.number}
                </div>
                {index !== steps.length - 1 && (
                  <div
                    ref={(el) => (lineRefs.current[index] = el)}
                    className="w-1 h-20 sm:h-28 bg-gray-700"
                  ></div>
                )}
              </div>

              {/* Card */}
              <div
                ref={(el) => (cardRefs.current[index] = el)}
                className="bg-[#0d0d0d] px-5 sm:px-8 py-8 sm:py-10 rounded-xl ml-5 sm:ml-8 w-full shadow-md transition-all cursor-pointer"
                onMouseEnter={() => handleHover(index, true)}
                onMouseLeave={() => handleHover(index, false)}
              >
                <h3 className="font-semibold text-lg sm:text-xl md:text-2xl mb-3 sm:mb-4">
                  {step.title}
                </h3>
                <p className="text-gray-400 text-sm sm:text-base leading-relaxed">
                  {step.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
